import { FOOTER_LEGAL, FOOTER_SOCIAL } from '../config/marketing-footer-columns';
import { TAGLINE } from '../constants';
import { MarketingLogo } from '@naumu/ui/components/marketing-logo';

/**
 * MarketingFooterSmall - the original single-row landing footer look: wordmark +
 * tagline on the left, social + a few links on the right. Reserved for lighter
 * pages; full public pages use the large footer.
 */
export const MarketingFooterSmall = () => (
	<footer className="border-t border-white/[0.04] px-6 py-10">
		<div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center sm:flex-row sm:justify-between sm:text-left">
			<div>
				<MarketingLogo className="justify-center sm:justify-start" />
				<p className="mt-1 text-[12px] text-white/40">{TAGLINE}</p>
			</div>

			<nav
				aria-label="Footer"
				className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2"
			>
				{FOOTER_SOCIAL.map((link) => {
					const Icon = link.icon;
					return (
						<a
							key={link.href}
							href={link.href}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={link.label}
							className="text-white/40 transition-colors hover:text-white"
						>
							{Icon ? <Icon className="h-4 w-4" /> : link.label}
						</a>
					);
				})}
				<a
					href="/docs"
					className="text-[12px] text-white/40 transition-colors hover:text-white"
				>
					Docs
				</a>
				{FOOTER_LEGAL.map((link) => (
					<a
						key={link.href}
						href={link.href}
						{...(link.external
							? { target: '_blank', rel: 'noopener noreferrer' }
							: {})}
						className="text-[12px] text-white/40 transition-colors hover:text-white"
					>
						{link.label}
					</a>
				))}
			</nav>
		</div>
	</footer>
);
